import { NoteType } from "../_enums/NoteType";
import { ResourceType } from "../_enums/ResourceType";

export interface INote {
    Id?: number;

    ResourceId: number;
    ResourceType: ResourceType;

    CreatedBy?: number;
    CreatedOn?: string;
    CreatedByUserId?: number;

    Comments: string;
    NoteType?: NoteType;
    UserName?: string;

    // --

    noteTypeString?: string;
}

export class NotesService {
    static $inject = ["$q", "$http"];

    constructor(
        private readonly $q: angular.IQService,
        private readonly $http: angular.IHttpService) { }

    getNotes(entityId: number, resourceType: ResourceType, noteType: NoteType): angular.IPromise<INote[]> {
        return this
            .$http<INote[]>({
                url: `/api/foundation/notes/${ResourceType[resourceType]}/${entityId}`,
                method: "GET",
                //cache: true
            })
            .then(response => {
                response.data = response.data.filter(n => n.NoteType == noteType);

                response.data.forEach(note => {

                    note.noteTypeString = NoteType[note.NoteType];
                });

                return response.data;
            });
    }

    addNote(note: INote): angular.IPromise<any> {

        return this
            .$http<INote[]>({
                url: `/api/foundation/notes/`,
                method: "POST",
                data: note
            })
            .then(response => {
                return response.data;
            });
    }
}
